import React, { useState, Component } from 'react';
// import '../../styles/spacing'
// import gh from '../'
import salamiPath from '../../assets/pølse.png'
import {isMobile} from 'react-device-detect';


class SalamiWall extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      classNames : 'salami-start pos-absolute fall-down-animation h-50px',
      rndPosition : [],
      rndRotation : [],
      rndDelay : []
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({classNames: "salami-end pos-absolute fall-down-animation fit-contain h-50px"})
    }, 1000)

    //Arrays for transformation
    var positionArr = [];
    var rotateArr = [];
    var delayArr = [];

    var salamiNumber = isMobile ? 50 : 100;

    for (var i = 0; i < salamiNumber; i++) {
        // note: we are adding a key prop here to allow react to uniquely identify each
        // element in this array. see: https://reactjs.org/docs/lists-and-keys.html
        positionArr.push(`${Math.random()*100}%`);
        rotateArr.push(`rotateY(${Math.random()*360}deg`);
        delayArr.push(`${Math.random()*25}s`);
        
    }
    this.setState({
      rndPosition : positionArr,
      rndRotation : rotateArr,
      rndDelay : delayArr
    
    })
  }


  

  render() {
    // const { content, cx, absolute, center } = this.props;
    // console.log(this.props.checked)

    //TODO TOGGLE TOAST CLASS AFTER 5 SECONDS

    // const arr = new Array(10).fill(`${Math.random()*100}px`);
    
    // console.log(this.state.rndPosition[0])
    // console.log(this.state.rndDelay[0])
    // console.log(this.state.rndRotation[0])

    const pageHeight = document.body.scrollHeight;

    // console.log(arr)
  
    return (
      <div className="pos-absolute w-100 h-100 hidden" style={{left: 0, zIndex: -10, height: pageHeight}} >
        {/* <img src="../../assets/pølse-cropped.png" className={this.state.classNames}>*FALLING SALAMIS*</img> */}

          {/* Salamis */}
          
            {this.state.rndPosition.map((rndPos, index) => (
                  
              
                  <img src={salamiPath} className={this.state.classNames} style={{left: `${rndPos}`, animationDelay: this.state.rndDelay[`${index}`]  }}/>
              
              ) 
            )}

          
          


        {/* <div className={this.state.classNames}>*FALLING SALAMIS*</div> */}
        </div>
    );
  
  }
}


export default SalamiWall;

// pos-absolute bottom-medium center-absolute left-50